"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataLayerBuilder_1 = __importDefault(require("./utils/DataLayerBuilder"));
/**
 * Creates dataLayer object
 */
const createDataLayerObject = ({ req, pageType, sellerBehaviour, loggedInUser, labsConfig = {}, categories, adDetails = {}, orderDetails = {}, consentedToAllPurposes = false, }) => new DataLayerBuilder_1.default()
    .withPageTypeAndLang(pageType, req.get('accept-language'))
    .withCategoryData(categories)
    .withLoggedInUserInfo(loggedInUser)
    .withAbSwitchesInfo(labsConfig.abSwitches)
    .withSellerBehaviour(sellerBehaviour)
    .withCookiesAndUserAgents(req)
    .withAdDetails(adDetails)
    .withOrderDetails(orderDetails)
    .withConsentToAllPurposes(consentedToAllPurposes)
    .withUserData(loggedInUser, labsConfig)
    .build();
exports.default = createDataLayerObject;
//# sourceMappingURL=createDataLayerObject.js.map